module.exports = __webpack_public_path__ + "img/share-qrcode.61a8f099.png";